// extracted by mini-css-extract-plugin
module.exports = {"text-grey":"d1L4Ze1MDKdbXEQmfKO1E"};